import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
// A labeled on/off switch. Unlike a bare sliding pill, it spells out its state
// ("On" / "Off") inside the track and colours the track (forest = on, pewter =
// off), so the current state is unambiguous on any background. Render it inside
// a button/role="switch" wrapper that owns the click + the descriptive label.
export const ToggleSwitch = ({ checked }) => (_jsxs("span", { className: "relative inline-block rounded-full transition-colors flex-shrink-0 border", style: {
        width: 52,
        height: 24,
        backgroundColor: checked ? 'var(--forest)' : 'var(--pewter)',
        borderColor: checked ? 'var(--forest)' : 'var(--dew)',
    }, children: [_jsx("span", { className: "absolute text-[10px] font-bold uppercase tracking-wide select-none pointer-events-none", style: {
                // Light text on both tracks (forest + pewter are both dark), so the
                // state word stays legible — charcoal-on-pewter was unreadable.
                color: checked ? 'var(--sand)' : 'var(--dew)',
                top: '50%',
                transform: 'translateY(-50%)',
                left: checked ? 8 : undefined,
                right: checked ? undefined : 8,
            }, children: checked ? 'On' : 'Off' }), _jsx("span", { className: "absolute rounded-full bg-white shadow-sm transition-all", style: {
                // Vertically centered via transform so the border can't throw it off;
                // left animates between the two ends.
                width: 18,
                height: 18,
                top: '50%',
                left: checked ? 30 : 2,
                transform: 'translateY(-50%)',
            } })] }));
